import { ERoomCount, ESuburbanEstimationCategory } from '@cian/valuation-main-filters-widget';
import { stringify } from 'qs';

interface IGetValuationFormUrlProps {
  address?: string | null;
  houseId?: number | null;
  roomsCount?: ERoomCount | null;
  totalArea?: number | null;
  estimationId?: number | null;
}

interface IGetSuburbanValuationFormUrlProps {
  address: string;
  houseId?: number | null;
  houseArea?: number;
  landArea: number;
  category: ESuburbanEstimationCategory;
}

type TFormParams = IGetValuationFormUrlProps | IGetSuburbanValuationFormUrlProps;

export function getDataPaymentFormUrl(formParams: TFormParams, absoluteUrl?: boolean) {
  const queryString = stringify(formParams, { skipNulls: true });

  let url = `/valuation-form/?${queryString}`;

  if (absoluteUrl && typeof window !== 'undefined') {
    url = window.location.origin + url;
  }

  return {
    queryString,
    url,
  };
}
